import api from './api';

const overtimeService = {
  // Get all overtime records
  getAllOvertime: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.employeeId) queryParams.append('employeeId', params.employeeId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.overtimeType) queryParams.append('overtimeType', params.overtimeType);
      if (params.compensationType) queryParams.append('compensationType', params.compensationType);

      const queryString = queryParams.toString();
      const url = `/overtime${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching overtime records:', error);
      throw error;
    }
  },

  // Get overtime by ID
  getOvertimeById: async (id) => {
    try {
      const response = await api.get(`/overtime/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching overtime record:', error);
      throw error;
    }
  },

  // Get next overtime number
  getNextOvertimeNumber: async () => {
    try {
      const response = await api.get('/overtime/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next overtime number:', error);
      throw error;
    }
  },

  // Create overtime record
  createOvertime: async (overtimeData) => {
    try {
      const response = await api.post('/overtime', overtimeData);
      return response.data;
    } catch (error) {
      console.error('Error creating overtime record:', error);
      throw error;
    }
  },

  // Update overtime record
  updateOvertime: async (id, overtimeData) => {
    try {
      const response = await api.put(`/overtime/${id}`, overtimeData);
      return response.data;
    } catch (error) {
      console.error('Error updating overtime record:', error);
      throw error;
    }
  },

  // Delete overtime record
  deleteOvertime: async (id) => {
    try {
      const response = await api.delete(`/overtime/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting overtime record:', error);
      throw error;
    }
  },

  // Get overtime statistics
  getOvertimeStats: async () => {
    try {
      const response = await api.get('/overtime/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching overtime statistics:', error);
      throw error;
    }
  },

  // Approve overtime
  approveOvertime: async (id, approvalNotes) => {
    try {
      const response = await api.put(`/overtime/${id}/approve`, { approvalNotes });
      return response.data;
    } catch (error) {
      console.error('Error approving overtime:', error);
      throw error;
    }
  },

  // Mark overtime as paid
  markOvertimeAsPaid: async (id, paymentReference) => {
    try {
      const response = await api.put(`/overtime/${id}/mark-paid`, { paymentReference });
      return response.data;
    } catch (error) {
      console.error('Error marking overtime as paid:', error);
      throw error;
    }
  }
};

export default overtimeService;

